import {
  buildTimeFromHM,
  clickEventType,
  convertTime12to24,
  followLink,
  parseTime,
} from '../helpers';
import { timeToFloat } from './shared';

$(document).ready(() => {
  $(() => {
    if ($('#end-of-day-wizard').length > 0) {
      $('.wizard-progress-bar').each(function () {
        const value = $(this).data('currentValue') * 100 / $(this).data('totalValues');
        $(this).progressbar({ value });
      });
      $('body').addClass('no-overflow');
    }
  });

  $(document).on('click', '#end-of-day-wizard-icon', function (e) {
    e.stopPropagation();
    $('body').removeClass('no-overflow');
    const date = $(this).data('date');
    followLink('/end_of_day_wizards/initial', { date });
  });

  $(document).on('click', '#end-of-day-wizard .wizard-close', () => {
    const date = $('#end-of-day-wizard #date').val();
    followLink('/planned_employee_days', { date_for_scroll: date, date });
  });

  function checkWizardAvailability(successCallback) {
    const date = $('#end-of-day-wizard-icon').data('date');
    $.ajax({
      url: '/end_of_day_wizards/is_available',
      data: { date },
      type: 'GET',
      success(jsonData) {
        successCallback(jsonData.wizard_available);
      },
    });
  }

  $(document).on('click', '#end-of-day-wizard .scrollable-container .employee', function () {
    $(this).toggleClass('selected');
    const taskIds = $('#end-of-day-wizard .selected.employee').map(function () {
      return $(this).data('taskId');
    }).toArray();
    $('#end-of-day-wizard #task_ids').val(taskIds);
  });

  $(document).on('click', '#end-of-day-wizard .next-step-button', () => {
    $('#end-of-day-wizard form').submit();
  });

  $(document).on('change', '#end-of-day-wizard .working-time-value', function () {
    var isSet = false;
    const workingTimeInput = $(this);
    if (workingTimeInput.children().val().length > 0) {
      $('#end-of-day-wizard .main-area').removeClass('base-red').addClass('base-green');
      var isSet = true;
    } else {
      debugger;
      $('#end-of-day-wizard .main-area').removeClass('base-green').addClass('base-red');
    }
    if (isSet !== (workingTimeInput.attr('is_set') === 'true')) {
      $('#end-of-day-wizard .bottom-bar .paired-element').toggleClass('hidden');
      $('#end-of-day-wizard .working-time .paired-element').toggleClass('hidden');
      $('#end-of-day-wizard .action-comment .paired-element').toggleClass('hidden');
    }
    workingTimeInput.attr('is_set', isSet);
  });

  function findClosestWeekDay() {
    if (($('.employee_day_mobile').length === 0) || $('#end-of-day-wizard-icon').length === 0) { return; }
    const iconTop = $('#end-of-day-wizard-icon').offset().top;
    const weekDays = $('.week_day_mobile');
    let closestWeekDay = null;
    weekDays.each(function () {
      if ($(this).offset().top < iconTop) {
        closestWeekDay = $(this);
      }
    });
    return closestWeekDay;
  }

  $('#planner-mobile').scroll(() => {
    if (($('.employee_day_mobile').length === 0) || ($('#end-of-day-wizard-icon').length === 0)) { return; }
    const weekDay = findClosestWeekDay();
    const date = weekDay.data('date');
    const employeeDayMobile = weekDay.closest('.employee_day_mobile');
    const oldDate = $('#end-of-day-wizard-icon').data('date');
    $('#end-of-day-wizard-icon').data('date', date);
    if (oldDate !== date) {
      $('#end-of-day-wizard-icon').trigger('wizardDateChanged');
    }
  });

  $(document).on('wizardDateChanged', '#end-of-day-wizard-icon', () => {
    const icon = $('#end-of-day-wizard-icon');
    const successCallback = function (wizardAvailable) {
      wizardAvailable ? icon.removeClass('invisible') : icon.addClass('invisible');
    };
    checkWizardAvailability(successCallback);
  });

  $(document).on('click', '#end-of-day-wizard .ignore-button', () => {
    $('#end-of-day-wizard #ignore_adding').val(true);
    $('#end-of-day-wizard form').submit();
  });
});
